import React from 'react'
import TableWidget4 from './TableWidget4'
import orders from '../json/orders.json'

const SampleTableWidget4 = () => <TableWidget4 items={orders} />

export default SampleTableWidget4



// WEBPACK FOOTER //
// ./src/table-widgets/SampleTableWidget4.js